import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Referrals',
        }
    }
})

function RouteComponent() {
    return <Outlet />
}
